// Admin Dashboard Constants
// This file contains all service categories and pricing for the cash register system

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_COLORS = {
  pending: 'bg-yellow-500',
  confirmed: 'bg-blue-500',
  completed: 'bg-green-500',
  cancelled: 'bg-red-500',
  in_progress: 'bg-orange-500',
  unread: 'bg-red-500',
  read: 'bg-zinc-600',
  draft: 'bg-zinc-500',
  sent: 'bg-blue-500',
  paid: 'bg-green-500'
};

export const STATUS_LABELS = {
  pending: 'En attente',
  sent: 'Envoyée',
  paid: 'Payée',
  cancelled: 'Annulée'
};

export const QUOTE_STATUS_LABELS = {
  pending: 'En attente',
  in_progress: 'En cours',
  quote_sent: 'Devis envoyé',
  accepted: 'Accepté',
  rejected: 'Refusé',
  converted: 'Converti en facture'
};

// Services prédéfinis pour la caisse
export const SERVICES_BY_CATEGORY = {
  wash: {
    label: '🚿 Lavages',
    services: [
      { description: 'VÉLO', price: 12 },
      { description: 'CLEAN', price: 25 },
      { description: 'VIP', price: 55 },
      { description: 'PLATINE', price: 75 },
      { description: 'PRESTIGE', price: 115 },
    ]
  },
  wash_abo: {
    label: '🎫 Abonnements Lavage',
    services: [
      { description: 'Abo VÉLO x12', price: 125 },
      { description: 'Abo CLEAN x12', price: 250 },
      { description: 'Abo VIP x12', price: 550 },
      { description: 'Abo PLATINE x12', price: 750 },
      { description: 'Abo PRESTIGE x12', price: 1150 },
    ]
  },
  supplements: {
    label: '➕ Suppléments Lavage',
    services: [
      { description: 'Supplément SUV / 4x4', price: 10 },
      { description: 'Supplément Véhicule 7 places', price: 20 },
      { description: 'Supplément Fiente de pigeon', price: 10 },
      { description: 'Supplément Petite Couronne', price: 10 },
      { description: 'Supplément Grande Couronne', price: 20 },
    ]
  },
  detailing: {
    label: '✨ Detailing & Rénovation',
    services: [
      { description: 'Nettoyage Sièges Tissu', price: 40 },
      { description: 'Nettoyage Sièges Cuir', price: 50 },
      { description: 'Polish Carrosserie', price: 80 },
      { description: 'Rénovation Phares', price: 45 },
      { description: 'Traitement Céramique', price: 299 },
      { description: 'Film Protection PPF', price: 0, label: 'Devis' },
    ]
  },
  depannage: {
    label: '🚗 Dépannage',
    services: [
      { description: 'Dépannage batterie / démarrage', price: 80 },
      { description: 'Remplacement batterie (pose incluse)', price: 119 },
      { description: 'Panne sèche (livraison carburant)', price: 129 },
      { description: 'Erreur carburant (vidange)', price: 190 },
      { description: 'Ouverture portière', price: 37 },
      { description: 'Ouverture parking sous-sol', price: 20, label: 'Suppl.' },
      { description: 'Crevaison / réparation pneu', price: 80 },
      { description: 'Changement roue de secours', price: 109 },
      { description: 'Absorbant hydrocarbure', price: 59 },
    ]
  },
  mecanique: {
    label: '🔧 Mécanique',
    services: [
      { description: 'Vidange Huile', price: 89 },
      { description: 'Vidange + Filtres', price: 129 },
      { description: 'Changement Plaquettes Freins AV', price: 120 },
      { description: 'Changement Plaquettes Freins AR', price: 100 },
      { description: 'Changement Disques + Plaquettes AV', price: 220 },
      { description: 'Équilibrage 4 Roues', price: 40 },
      { description: 'Parallélisme', price: 60 },
      { description: 'Montage Pneus (x4)', price: 60 },
      { description: 'Diagnostic Électronique', price: 45 },
      { description: 'Révision Complète', price: 199 },
      { description: 'Climatisation Recharge', price: 79 },
    ]
  },
  carrosserie: {
    label: '🎨 Carrosserie',
    services: [
      { description: 'Débosselage sans peinture', price: 0, label: 'Devis' },
      { description: 'Retouche peinture', price: 0, label: 'Devis' },
      { description: 'Remplacement pare-brise', price: 0, label: 'Devis' },
      { description: 'Réparation impact pare-brise', price: 89 },
    ]
  },
  produits: {
    label: '🛒 Produits',
    services: [
      { description: 'Huile Moteur 5W30 (5L)', price: 45 },
      { description: 'Huile Moteur 5W40 (5L)', price: 40 },
      { description: 'Liquide de Refroidissement (2L)', price: 15 },
      { description: 'Lave-Glace (5L)', price: 8 },
      { description: 'Désodorisant Habitacle', price: 12 },
      { description: 'Batterie (selon modèle)', price: 89 },
    ]
  },
  autres: {
    label: '📋 Autres',
    services: [
      { description: "Main d'œuvre (1h)", price: 55 },
      { description: 'Forfait Diagnostic', price: 45 },
      { description: 'Carte grise', price: 0, label: 'Devis' },
      { description: 'Contrôle technique', price: 0, label: 'Devis' },
    ]
  }
};

// Company info for invoices and receipts
export const COMPANY_INFO = {
  name: 'SAS KD AUTO SERVICE',
  address: '142 boulevard Murat, 75016 Paris',
  phone: '0805 032 032',
  email: 'info@lehubatelier.fr',
  siren: '989 707 260',
  siret: '989 707 260 00018',
  tva: 'FR01989707260',
  logoUrl: 'https://customer-assets.emergentagent.com/job_5fa86a42-f7fc-4c7b-82aa-e23c2c93b925/artifacts/cpgdckfz_image.png'
};

// Initial form state for sales
export const INITIAL_SALE_FORM = {
  items: [{ description: '', category: 'service', quantity: 1, unit_price: '', total: 0 }],
  payment_method: 'cash',
  cash_amount: '',
  card_amount: '',
  check_amount: '',
  check_number: '',
  cash_given: '',
  cash_change: 0,
  client_id: '',
  client_name: '',
  client_email: '',
  client_phone: '',
  vehicle_plate: '',
  vehicle_model: '',
  vehicle_year: '',
  vehicle_color: '',
  notes: ''
};

// Initial form state for invoices
export const INITIAL_INVOICE_FORM = {
  user_id: '',
  user_name: '',
  user_email: '',
  user_phone: '',
  user_firstname: '',
  user_company: '',
  amount: '',
  description: '',
  items: [{ description: '', quantity: 1, unit_price: '' }]
};

// Initial form state for quotes
export const INITIAL_QUOTE_FORM = {
  client_name: '',
  client_email: '',
  client_phone: '',
  client_company: '',
  client_address: '',
  vehicle_brand: '',
  vehicle_model: '',
  vehicle_plate: '',
  vehicle_year: '',
  items: [{ description: '', quantity: 1, unit_price: '' }],
  notes: '',
  validity_days: 30
};
